<template>
  <div id="pageFirstAccess" class="mt-5">
    <v-container fill-height grid-list-lg fluid class="d-block">

      <!-- Stepper aparece apenas quando não existe nenhuma propriedade cadastrada -->
      <v-stepper v-if="localHome.properties <= 0" v-model="stepperPosition" alt-labels class="mb-3" style="max-width: 600px; margin: 0 auto">
        <h2 class="title font-weight-medium d-block text-center blue-grey--text text--darken-1 py-2" style="margin: 0 auto;">Mais 1 passo e você finaliza seu cadastro</h2>
        <v-stepper-header>
          <v-stepper-step complete step="1" color="green" class="ignoreMediaFilter"><span class="text-center blue-grey--text text--darken-1">Cadastro Usuário</span></v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="stepperPosition > 2" step="2" color="orange" class="ignoreMediaFilter"><span class="text-center blue-grey--text text--darken-1">Cadastro Propriedade</span></v-stepper-step>
        </v-stepper-header>
      </v-stepper>

      <!-- Card com opções de acesso. Muda conteúdo interno dependendo da situação do usuário -->
      <v-card max-width="600px">
        <div id="default-screen">
          <v-card-text class="blue-grey--text text--darken-1">
            <p class="text-center subtitle-1 font-weight-light">
              Olá <b class="text-user-name">{{ this.$auth.user().name }},</b> seja bem-vindo na
              plataforma Trace Beef!
            </p>
            <h2 class="title font-weight-regular text-center text-uppercase">
              O que deseja?
            </h2>
            <v-row v-if="localHome && localHome.properties > 0">
              <v-btn
                dark
                class="btn-property"
                color="light-blue darken-3"
                :to="{ name: 'PropertyIndex' }"
              >
                <v-icon class="icon-farm"></v-icon>
                <v-badge color="red " right bottom overlap>
                  <template v-slot:badge>
                    {{ localHome.properties }}
                  </template>
                  Propriedades
                </v-badge>
              </v-btn>
            </v-row>
            <v-row>
              <v-btn
                dark
                color="light-blue darken-3"
                @click="newPropertyDialog = true"
              >
                <v-icon class="icon-add-page"></v-icon>
                Cadastrar nova propriedade
              </v-btn>
            </v-row>
          </v-card-text>
        </div>
      </v-card>

      <!-- Componente cadastrar nova propriedade -->
      <v-dialog v-model="newPropertyDialog" max-width="600" persistent>
        <NewProperty @close="close"/>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue"
import appApi from "../../plugins/api"
import NewProperty from '@/components/property/PropertyAdd'

export default {
  components: {
    'NewProperty' : NewProperty
  },

  props: ["homeButton", "home"],

  data() {
    return {
      localHome: null,
      newPropertyDialog: false,
      stepperPosition: 2
    };
  },

  created() {
    if (!this.home) {
      appApi.getHome().then(result => {
        this.localHome = result.data;
      });
    } else {
      this.localHome = this.home;
    }
  },

  mounted() {
    this.getPageWraper();
  },

  destroyed() {
    this.$store.state.showBottomMenu = true;
    this.getPageWraper();
  },

  methods: {
    getPageWraper() {
      var wraper = document.getElementById("page-wrapper");
      if (!this.pageWraper) {
        this.pageWraper = true;
        wraper.style.paddingBottom = "0px";
      } else {
        this.pageWraper = false;
        wraper.removeAttribute("style");
      }
    },

    close() {
      this.newPropertyDialog = !this.newPropertyDialog
    }
  }
};
</script>

<style lang="scss" scoped>

#pageFirstAccess::v-deep {

  .v-card {
    width: 100%;
    margin: 0 auto;
  }

  .v-stepper {
    .v-stepper__header {
      box-shadow: none;
    }
    
    .v-stepper__step--active {
      .v-stepper__label {
        text-shadow: none;
      }
    }

    .v-stepper__step__step {
      font-size: 16px;
      font-weight: bold;
    }

    @media only screen and (max-width: 959px)
    {
        .ignoreMediaFilter .v-stepper__label {
            display: flex !important;
            text-align: center;
        }
    }
    @media only screen and (min-width: 959px)
    {
        .ignoreMediaFilter .v-stepper__label {
            display: flex !important;
            text-align: center;
        }
    }
  }

  #default-screen{
    button,
    a {
      display: block;
      height: auto;
      max-width: 300px;
      width: 100%;
      color: white;
      margin: 20px auto;
      padding: 20px;
      white-space: normal;

      @media screen and (max-width: 360px) {
        max-width: 100%;
      }

      span {
        max-width: 100%;
        width: 100%;

        i {
          margin-right: 20px;
        }
      }
    }

    a.btn-property {
      span {
        width: inherit;
        text-align: center;
        i {
          margin: 0;
        }

        .v-badge {
          width: 100%;
        }
        
        span.v-badge__badge {
          width: auto;
          padding: 0 8px;
          line-height: 20px;
        }
      }
    }
  }
}
</style>
